import { uuid } from "./componentId";

/** 与 uuid 一致：纯数字字符串，避免 Number 精度丢失 */
export default function generateID() {
  return uuid();
}
